import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    sortObjects: {
        sortMulti: {}
    }
};

const SortReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SORT_UPDATE_SORTOBJECTS:
            return {
                loading: true
            }
        case actionTypes.SORT_UPDATE_SORTOBJECTS_SUCCESS:
            return {
                loading: false,
                sortObjects: { ...state.sortObjects, ...action.payload }
            }
        case actionTypes.SORT_SET_INITIAL_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default SortReducer;